import { OrganisationRoutesEnum } from '@utilities/enums';
import { fetchRequest } from '@utilities/requests';
import { FetchResponseType, Organisation } from '@utilities/types';

export const organisationService =  {

    update: async (id: string, updatedOrganisation: Partial<Organisation>): Promise<FetchResponseType> => {
        const response = await fetchRequest({
            route: `${OrganisationRoutesEnum.ORGANISATION_UPDATE}/${id}`,
            method: 'PUT',
            data: updatedOrganisation,
        });

        return response;
    },
};
